import { fromJS } from 'immutable';
import {
  SET_LAST_ASSIGNED_CLAIMS,
  SET_SEARCH_QUERY,
  SET_SELECTED_RESULT_SEARCH,
  RESET_STORE_SEARCH,
} from 'containers/ManagerHomePage/constants';

const initialState: any = fromJS({
  lastAssingnedClaims: [],
  searchQuery: {},
  selectedResultSearch: {},
});

const ManagerHomePageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LAST_ASSIGNED_CLAIMS:
      return state.set('lastAssingnedClaims', fromJS(action.payload));
    case SET_SEARCH_QUERY:
      return state.set('searchQuery', fromJS(action.payload));
    case SET_SELECTED_RESULT_SEARCH:
      return state.set('selectedResultSearch', fromJS(action.payload));
    case RESET_STORE_SEARCH:
      return initialState;
    default:
      return state;
  }
};

export default ManagerHomePageReducer;
